<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" :title="dialogTitle" width="980px" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="120px" v-loading="dialogLoading">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="name" label="工单名称">
            <el-input v-model.trim="dataForm.name" placeholder="" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="type" label="类别">
            <el-select v-model="dataForm.type" style="width: 100%;" placeholder="" clearable @change="handleTypeChange">
              <el-option v-for="item in typeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="startTime" label="计划开始日期">
            <el-date-picker
              :picker-options="pickerOptions"
              style="width: 100%;"
              v-model="dataForm.startTime"
              type="date"
              placeholder="计划开始日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="endTime" label="计划结束日期">
            <el-date-picker
              :picker-options="pickerOptions"
              style="width: 100%;"
              v-model="dataForm.endTime"
              type="date"
              placeholder="计划结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="equipment" label="关联设备">
            <el-select v-model="dataForm.equipment" style="width: 100%;" multiple placeholder="" clearable>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="workingArea" label="工作区域">
            <el-input placeholder="" v-model="dataForm.workingArea"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="describe" label="描述">
            <el-input type="textarea" :rows="2" placeholder="" v-model="dataForm.describe">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'addOrUpdate',
  props: {
    dialogTitle: {
      type: String,
      default: '新建工单'
    },
    isRedispatch: {
      type: Boolean,
      default: false
    },
    typeList: Array
  },
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      size: 'small',
      dialogLoading: false,
      visible: false,
      dataForm: {
        companyId: 0,
        name: '',
        contractId: '',
        type: '',
        startTime: '',
        endTime: '',
        describe: '',
        equipment: [],
        attachments: [],
        planId: '',
        clientEventRecordId: 0
      },
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        // equipment: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  methods: {
    init (row, title) {
      this.title = title
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.dataForm.id = row.id
        Promise.all([]).then(() => {
          if (this.dataForm.id) {
            this.handleGetInfo()
          }
        })
      })
    },
    handleGetInfo () {
    },
    submitHandle:debounce (function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dialogLoading = true
        this.$api.electricOperations.addElectricOperationsWorkOrder(
          0, 
          this.dataForm.contractId, 
          this.dataForm.serviceItemId
        ).then((res) => {
          this.dialogLoading = false
          if (res.success) {
            this.visible = false
            this.$message.success('操作成功')
            this.$emit('handleQuery')
          }
        })
      })
    }, 1000, { 'leading': true, 'trailing': false } )
  }
}
</script>

<style lang="scss" scoped>
</style>
